import * as bus from "@sinch/bus";
import { type FC } from "react";
import { useIntl } from "react-intl";
import styled, { css } from "styled-components";
import { NavIcon } from "../NavigationBar/NavIcon";
import { SIDEBAR } from "../NavigationBar/constants";
import { useSidebarState } from "../NavigationBar/state";
import { breakpoints } from "../NavigationBar/theme";

const MMPrimaryColor = "#0A5D9A";
const ItemText = styled.h1`
  margin: 0 0 0 ${SIDEBAR.itemTextMargin}px;
  font: var(--sinch-sys-font-desktop-title-s);
  color: var(--sinch-ref-color-main-snow-100);
  font-size: var(--sinch-ref-typography-font-size-14);
  line-height: var(--sinch-ref-typography-line-height-16);
  white-space: nowrap;
`;

const large = 40;
const small = 32;
const IconWrapper = styled.div`
  position: relative;
  width: ${large}px;
  height: ${large}px;
  box-sizing: border-box;
  border-radius: 4px;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;

  @media screen and (max-height: ${breakpoints.heightM}px) {
    & {
      width: ${small}px;
      height: ${small}px;
      border-radius: 4px;
    }

    svg {
      height: 18px;
      width: 18px;
    }
  }
`;

const QuickButtonWrapper = styled.div<{ isCollapsed: boolean }>`
  display: flex;
  flex: 1;
  justify-content: flex-start;
  flex-direction: column;
  ${({ isCollapsed }) =>
    isCollapsed &&
    css`
      align-items: center;
    `}
  padding: 14px 10px;

  @media screen and (max-height: ${breakpoints.heightS}px) {
    & {
      padding: 6px 10px;
    }
  }
`;

const QuickButton = styled.div`
  min-height: ${large}px;
  height: ${large}px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  background-color: ${MMPrimaryColor};
  cursor: pointer;

  @media screen and (max-height: ${breakpoints.heightM}px) {
    & {
      min-width: ${small}px;
      min-height: ${small}px;
      height: ${small}px;
      border-radius: 4px;
    }
  }

  &:hover {
    background-color: ${MMPrimaryColor};
  }
`;

type QuickMessageButtonProps = {
  show?: boolean;
};
export const QuickMessageButton: FC<QuickMessageButtonProps> = ({
  show = false,
}) => {
  const intl = useIntl();
  const sidebarState = useSidebarState();

  const openQuickMessageDialog = () => {
    bus.sendLocal(
      bus.quickMessageActionMessage({
        action: "open",
      })
    );
  };
  if (!show) {
    return <></>;
  }
  return (
    <QuickButtonWrapper isCollapsed={sidebarState.isCollapsed}>
      <QuickButton onClick={() => openQuickMessageDialog()}>
        <IconWrapper>
          <NavIcon name="mm-quick-message" />
        </IconWrapper>
        {!sidebarState.isCollapsed && (
          <ItemText>
            {intl.formatMessage({ id: "menuItemQuickMessage" })}
          </ItemText>
        )}
      </QuickButton>
    </QuickButtonWrapper>
  );
};
